import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import X46MK2TransomConfiguratorImage from './X46MK2TransomConfiguratorImage'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView03ImageOptions } from './views/ExteriorView03'

class X46MK2HullTreatment extends Component {
  constructor (props) {
    super(props)
    this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this)
  }

  handleHullTreatmentChange (newValue) {
    let configuration = this.props.configuration
    configuration.HullTreatment = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView03ImageOptions

    let image = (
      <X46MK2TransomConfiguratorImage
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2700, height: 660 }}
        transform={[
          0.038924, -0.026352, 0, -5.4e-5, 0.005899, 0.057562, 0, -3.8e-6, 0, 0,
          1, 0, 169.756991, 176.543629, 0, 1
        ]}
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Hull Treatment' />
          </h1>

          <p>
            <Trans defaults='3 layers of sprayed epoxy primer &amp; 2 layers of antifouling paint' />
          </p>

          <RadioGroup
            label={this.props.t('Treatment options:')}
            options={this.props.hullTreatmentOptions}
            value={this.props.configuration.HullTreatment}
            onChange={this.handleHullTreatmentChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2HullTreatment)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2HullTreatment.js